<template>
    <div class="animated fadeIn">
        <div style="position: relative">
            <b-spinner v-if="loading" variant="primary"
                style="position: absolute;bottom:3px;right:20px;z-index: 999"></b-spinner>
            <div ref="mapTooltip" class="map-tooltip" :style="{
                display: showMapTooltip ? 'block' : 'none',
                left: tooltipPosition.x + 'px',
                top: tooltipPosition.y + 'px'
            }">
                Chọn vị trí của bạn
            </div>
            <l-map style="height: 92vh" :zoom="zoom" :center="center" ref="myMap" :options="{
                zoomControl: false,
                maxZoom: 18,
                attributionControl: false
            }">
                <l-control position="topright">
                    <div class="leaflet-bar">
                        <a @click="makeEmergencyCall" title="Gọi hỗ trợ kỹ thuật" role="button"
                            aria-label="Gọi hỗ trợ kỹ thuật">
                            <i class="fa fa-phone fa-lg"></i>
                        </a>
                    </div>
                </l-control>
                <l-control-zoom position="topright" :options="zoomOption" />
                <l-control position="topright">
                    <div class="leaflet-bar">
                        <a @click="refreshMapView" title="Xem toàn cảnh" role="button" aria-label="Xem toàn cảnh">
                            <i class="fa fa-arrows-alt fa-lg" />
                        </a>
                        <a @click="refreshMap" title="Làm mới bản đồ" role="button" aria-label="Làm mới bản đồ">
                            <i class="fa fa-refresh fa-lg" />
                        </a>
                    </div>
                </l-control>
                <div>
                    <l-marker :lat-lng="[item.lat, item.long]" @click="openLayerModal(item)"
                        v-for="item in listLayerPoint" :key="item.id" ref="pointMarkers"
                        :options="{ pointId: item.id }">
                        <l-tooltip>{{ item.name }}</l-tooltip>
                        <l-icon>
                            <div class="station-bg" :style="{
                                backgroundColor: getMarkerColor1(item)
                            }">
                                <div class="font-weight-bold" :style="{
                                    backgroundColor: getMarkerColor2(item)
                                }">
                                    <span>{{ formatNumber(item?.data?.value) }}</span>
                                </div>
                            </div>
                        </l-icon>
                    </l-marker>
                </div>
                <div>
                    <l-marker :lat-lng="[item.lat, item.long]" v-for="item in listLayerPhoto" :key="item.id">
                        <l-tooltip>{{ item.description }}</l-tooltip>
                        <l-icon>
                            <img :src="getPhotoIcon(item)" :width="item.layer?.iconSize ?? 20"
                                :height="item.layer?.iconSize ?? 20" />
                            <i v-if="item.isResolved" class="fa fa-check"
                                style="color: green; position: absolute; top: 0px; right: -20px; font-size: 20px"></i>
                        </l-icon>
                        <l-popup>
                            <b-carousel controls img-width="200" style="min-width: 200px;">
                                <b-carousel-slide v-for="path in item.images" :key="path">
                                    <template #img>
                                        <img v-if="isImage(path)" class="d-block img-fluid w-100" width="200"
                                            :src="API_CONFIG.BASE_URL + 'download?fileName=' + path" />
                                        <video v-else class="d-block img-fluid w-100" width="200" controls
                                            :src="API_CONFIG.BASE_URL + 'download?fileName=' + path"></video>
                                    </template>
                                </b-carousel-slide>
                            </b-carousel>
                            <b-form-group>
                                <b-form-textarea rows="3" class="mt-2" v-model="item.description" />
                            </b-form-group>
                            <b-form-checkbox v-model="item.isResolved">
                                Đã trợ giúp xong/Không cần trợ giúp
                            </b-form-checkbox>
                            <b-button variant="primary" @click="savePhotoItem(item)">Lưu</b-button>
                        </l-popup>
                    </l-marker>
                </div>
            </l-map>
            <div style="position: absolute;top: 0px;left: 0px;z-index: 1000;height: 100%" ref="leftSidePanel">
                <div style="position: relative;height: 100%">
                    <div :style="{ display: showLeftSide ? 'block' : 'none' }"
                        style="width: 300px;background-color: #fff;height: 100%" class="pt-2 px-3">
                        <b-form-group label="Thông tin trợ giúp:">
                            <b-form-radio-group v-model="cuuHoId" :options="cuuHoOptions" name="type" />
                        </b-form-group>
                        <div style="max-height: 90%; overflow-y: auto; margin-bottom: 20px;">
                            <div v-for="item in listCuuHo" :key="item.id" class="mb-2 p-2"
                                :style="{ border: '1px solid #ddd', cursor: 'pointer' }"
                                @click="onClickCuuHoItem(item)">
                                <div class="d-flex align-items-center">
                                    <img :src="getPhotoIcon(item)" :width="item.layer?.iconSize ?? 20" class="mr-2" />
                                    <div>
                                        <div class="font-weight-bold">{{ item.description || 'Chưa có mô tả' }}</div>
                                        <div style="font-size: 12px; color: gray">
                                            {{ formatRelativeTime(item.createdAt) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="listCuuHo.length === 0" class="text-muted text-center py-3">
                                Không có thông tin
                            </div>
                        </div>
                    </div>
                    <b-button variant="primary"
                        style="position: absolute;right: -17px;top: 50%;padding-left: 5px;padding-right: 5px;"
                        @click="showLeftSide = !showLeftSide">
                        <i :class="`fa fa-caret-${showLeftSide ? 'left' : 'right'}`" aria-hidden="true"></i>
                    </b-button>
                </div>
            </div>
            <div class="emergency-call-button" @click="openUploadImageModal">
                <i class="fa fa-exclamation-triangle"></i>
                <span>Giúp tôi</span>
            </div>
        </div>

        <b-modal v-model="showDataModal" hide-header hide-footer centered size="lg" modal-class="station-modal">
            <Statistic :point="selectedPoint" />
        </b-modal>

        <b-modal v-model="showLayerModal" hide-header hide-footer centered size="lg" modal-class="station-modal">
            <StatisticCompare :point="selectedPoint" :listLayerPoint="listLayerPoint" />
        </b-modal>

        <b-modal title="Thêm thông tin trợ giúp" no-close-on-esc no-close-on-backdrop v-model="showCuuHoModal">
            <b-form-group label="Loại thông tin">
                <b-form-radio-group v-model="form.layerId" :options="cuuHoOptions" name="type" />
            </b-form-group>
            <b-form-group label="Vĩ độ">
                <b-form-input v-model="form.lat" v-validate="'required'" placeholder="Vĩ độ" name="lat" type="number"
                    data-vv-as="Vĩ độ"></b-form-input>
                <div v-show="errors.has('lat')" class="validation-message text-danger">
                    {{ errors.first('lat') }}
                </div>
            </b-form-group>
            <b-form-group label="Kinh độ">
                <b-form-input v-model="form.long" v-validate="'required'" placeholder="Kinh độ" type="number"
                    name="long" data-vv-as="Kinh độ"></b-form-input>
                <div v-show="errors.has('long')" class="validation-message text-danger">
                    {{ errors.first('long') }}
                </div>
            </b-form-group>
            <b-form-group label="Tên địa điểm">
                <b-form-input v-model="form.name" v-validate="'required'" placeholder="Tên địa điểm" type="text"
                    name="name" data-vv-as="Tên địa điểm"></b-form-input>
                <div v-show="errors.has('name')" class="validation-message text-danger">
                    {{ errors.first('name') }}
                </div>
            </b-form-group>
            <b-form-group label="Mô tả">
                <b-form-textarea v-if="isNeedHelpForm" v-model="form.description" rows="3"
                    placeholder="Cung cấp thông tin bao gồm: Họ tên, số điện thoại liên lạc, yêu cầu trợ giúp của bạn" />
                <b-form-textarea v-else v-model="form.description" rows="3"
                    placeholder="Cung cấp thông tin bao gồm: Địa điểm nhóm định đến, bạn hỗ trợ những gì số người dân (chủng loại và số lượng tương ứng)" />
            </b-form-group>
            <b-form-group label="Hình ảnh, video">
                <b-form-file v-model="listFile" accept="image/*,video/*" capture multiple name="listFile"
                    placeholder="Chưa có ảnh, video nào được chọn" browse-text="Chụp" data-vv-as="Hình ảnh, video" />
            </b-form-group>
            <template #modal-footer>
                <b-button variant="secondary" @click="showCuuHoModal = false">
                    {{ $t('common.cancel') }}
                </b-button>
                <b-button variant="primary" @click="updateLocate" :disabled="loading">
                    <b-spinner v-if="loading" small /> Thêm
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import API_CONFIG from '@/api-config';
import Statistic from '@/components/StatisticUser';
import StatisticCompare from '@/components/StatisticCompareUser';
import CONSTANTS from '@/constants';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

const HELP_MAP_TYPE = 'Trợ giúp';
const HELP_MAP_CONFIG_KEY = 'tro_giup';
const CUU_HO_LAYER_NAMES = ['Cần giúp', 'Sẵn sàng giúp'];

export default {
    components: {
        Statistic,
        Treeselect,
        StatisticCompare
    },
    data() {
        return {
            zoom: 6,
            center: [16.047079, 106.20623],
            zoomOption: {
                zoomInTitle: 'Phóng to',
                zoomOutTitle: 'Thu nhỏ'
            },
            showDataModal: false,
            showLayerModal: false,
            selectedBaseMap: [],
            listBaseMap: [],
            selectedLayerMap: [],
            listLayerMap: [],
            listLayerActive: {},
            listPoint: [],
            listLayerPoint: [],
            listPhoto: [],
            listLayerPhoto: [],
            selectedPoint: {},
            API_CONFIG,
            loading: false,
            showCuuHoModal: false,
            form: {},
            listFile: [],
            showLeftSide: true,
            listSelectedId: [],
            cuuHoId: null,
            listCuuHo: [],
            showMapTooltip: false,
            tooltipPosition: { x: 0, y: 0 }
        };
    },
    async mounted() {
        await this.$nextTick();
        this.initMapControl();

        const [listBaseMap, listLayerMap, defaultView] = await Promise.all([
            this.getLayerTree({ type: 'base' }),
            this.getLayerTree({ type: 'layer' }),
            this.getMapView(HELP_MAP_CONFIG_KEY)
        ]);
        if (defaultView) {
            this.center = defaultView.center;
            this.zoom = defaultView.zoom;
        }
        this.listBaseMap = listBaseMap;
        this.listLayerMap = this.filterCuuHoLayerTree(
            this.filterSelectableHelpLayerTree(listLayerMap)
        );
        this.selectedBaseMap = this.getDefaultLayer(this.listBaseMap);
        this.initSelectedCuuHoLayer();

        const [listPoint, listPhoto] = await Promise.all([this.getListPoint(), this.getListPhoto()]);
        this.listPoint = Array.isArray(listPoint) ? listPoint : [];
        this.listPhoto = Array.isArray(listPhoto) ? listPhoto : [];
        this.syncSelectedLayerItems(this.selectedLayerMap);

        const map = this.$refs.myMap.mapObject;
        map.on('click', this.handleMapClickCuuHo);
        map.on('mousemove', this.handleMapMouseMove);
        map.on('mouseout', this.hideMapTooltip);

        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        const map = this.$refs.myMap?.mapObject;
        if (map) {
            map.off('click', this.handleMapClickCuuHo);
            map.off('mousemove', this.handleMapMouseMove);
            map.off('mouseout', this.hideMapTooltip);
        }
        document.removeEventListener('click', this.handleClickOutside);
    },
    watch: {
        selectedBaseMap(newValue, oldValue) {
            this.updateLayer(newValue, oldValue);
        },
        selectedLayerMap(newValue, oldValue) {
            this.syncSelectedLayerItems(newValue);
            this.updateLayer(newValue, oldValue);
        },
        cuuHoId(value) {
            const selectedLayer = this.helpSelectableLayers.find(item => item.id === value);
            this.selectedLayerMap = selectedLayer ? [selectedLayer] : [];
            this.syncCuuHoList();
        }
    },
    computed: {
        baseMapPlaceholder() {
            const count = this.selectedBaseMap?.length ?? 0;
            if (count === 0) return 'Chọn bản đồ nền';
            return `${count} bản đồ nền`;
        },
        layerMapPlaceholder() {
            const count = this.selectedLayerMap?.length ?? 0;
            if (count === 0) return 'Chọn lớp dữ liệu';
            return `${count} lớp dữ liệu`;
        },
        helpSelectableLayers() {
            return this.sortCuuHoLayers(
                this.getLeafLayers(this.listLayerMap).filter(item => this.isCuuHoLayer(item))
            );
        },
        cuuHoOptions() {
            return this.helpSelectableLayers.map(item => ({
                text: this.getCuuHoLayerLabel(item),
                value: item.id
            }));
        },
        isNeedHelpForm() {
            const selectedLayer = this.helpSelectableLayers.find(
                item => String(item.id) === String(this.form?.layerId)
            );
            return this.getCuuHoLayerLabel(selectedLayer) === 'Cần giúp';
        }
    },
    methods: {
        ...mapActions({
            getListPoint: 'point/getList',
            getListPhoto: 'photo/getList',
            getLayerTree: 'mapLayer/getListTree',
            upload: 'file/upload',
            createPhotoPoint: 'photo/create',
            updatePhotoPoint: 'photo/update',
            getMapView: 'config/getMapView'
        }),
        initMapControl() {
            const map = this.$refs.myMap.mapObject;

            const measureControl = new L.Control.Measure({
                position: 'topright',
                activeColor: 'blue',
                completedColor: 'red',
                primaryLengthUnit: 'kilometers',
                secondaryLengthUnit: undefined,
                primaryAreaUnit: 'hectares',
                secondaryAreaUnit: undefined
            });
            measureControl.addTo(map);

            L.control
                .locate({
                    strings: {
                        title: 'Hiển thị vị trí hiện tại',
                        popup: 'Bạn cách vị trí hiện tại {distance} mét'
                    },
                    position: 'topright',
                    onLocationError: () => {
                        this.$toaster.error('Không thể lấy thông tin vị trí hiện tại');
                    }
                })
                .addTo(map);

            const editableLayers = new L.FeatureGroup();
            map.addLayer(editableLayers);

            const baseMap = {};

            for (const option of CONSTANTS.BASE_MAP_OPTIONS) {
                const layerOptions = { maxZoom: 20 };
                if (option.subdomains) layerOptions.subdomains = option.subdomains;
                const layer = L.tileLayer(option.url, layerOptions);
                baseMap[option.label] = layer;
            }
            Object.values(baseMap)[0].addTo(map);

            L.control
                .layers(baseMap, null, {
                    position: 'bottomleft'
                })
                .addTo(map);
        },
        async openDataModal(data) {
            this.selectedPoint = data;
            this.showDataModal = true;
        },
        async openLayerModal(data) {
            this.selectedPoint = data;
            this.showLayerModal = true;
        },
        refreshMapView() {
            this.$refs.myMap.mapObject.setView(this.center, this.zoom);
        },
        refreshMap() {
            this.$refs.myMap.mapObject.eachLayer(layer => {
                if (
                    layer instanceof L.Circle ||
                    layer instanceof L.Rectangle ||
                    layer instanceof L.Path ||
                    layer instanceof L.Polygon
                ) {
                    this.$refs.myMap.mapObject.removeLayer(layer);
                }
            });
            this.refreshMapView();
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            };
        },
        getLeafLayers(nodes = []) {
            let layers = [];
            for (const node of nodes || []) {
                if (Array.isArray(node.children) && node.children.length > 0) {
                    layers = layers.concat(this.getLeafLayers(node.children));
                } else {
                    layers.push(node);
                }
            }
            return layers;
        },
        sortCuuHoLayers(layers = []) {
            return [...layers].sort((a, b) => {
                const indexA = CUU_HO_LAYER_NAMES.findIndex(text => String(a?.name || '').includes(text));
                const indexB = CUU_HO_LAYER_NAMES.findIndex(text => String(b?.name || '').includes(text));
                const safeIndexA = indexA === -1 ? CUU_HO_LAYER_NAMES.length : indexA;
                const safeIndexB = indexB === -1 ? CUU_HO_LAYER_NAMES.length : indexB;
                if (safeIndexA !== safeIndexB) return safeIndexA - safeIndexB;
                return String(a?.name || '').localeCompare(String(b?.name || ''), 'vi');
            });
        },
        isCuuHoLayer(node) {
            return CUU_HO_LAYER_NAMES.some(text => String(node?.name || '').includes(text));
        },
        getCuuHoLayerLabel(node) {
            return CUU_HO_LAYER_NAMES.find(text => String(node?.name || '').includes(text)) || node?.name;
        },
        initSelectedCuuHoLayer() {
            const defaultLayers = this.sortCuuHoLayers(
                this.getDefaultLayer(this.listLayerMap).filter(item => this.isCuuHoLayer(item))
            );
            const selectedLayer = defaultLayers[0] || this.helpSelectableLayers[0];
            this.cuuHoId = selectedLayer?.id ?? null;
            this.selectedLayerMap = selectedLayer ? [selectedLayer] : [];
        },
        nodeMatchesMapType(node) {
            if (node?.type === HELP_MAP_TYPE) return true;
            if (!Array.isArray(node?.mapShow)) return false;
            return node.mapShow.includes(HELP_MAP_TYPE);
        },
        filterLayerTreeByMapShow(nodes = []) {
            return (nodes || [])
                .map(node => {
                    const filteredChildren = Array.isArray(node.children)
                        ? this.filterLayerTreeByMapShow(node.children)
                        : [];
                    if (!this.nodeMatchesMapType(node) && filteredChildren.length === 0) return null;
                    if (!Array.isArray(node.children)) return node;
                    if (filteredChildren.length === node.children.length) return node;
                    return {
                        ...node,
                        children: filteredChildren
                    };
                })
                .filter(Boolean);
        },
        filterSelectableHelpLayerTree(nodes = []) {
            return this.filterLayerTreeByMapShow(nodes)
                .map(node => {
                    if (!Array.isArray(node.children)) return node;
                    return {
                        ...node,
                        children: this.filterSelectableHelpLayerTree(node.children)
                    };
                })
                .filter(node => !this.isFileMapLayer(node));
        },
        filterCuuHoLayerTree(nodes = []) {
            return (nodes || [])
                .map(node => {
                    const filteredChildren = Array.isArray(node.children)
                        ? this.filterCuuHoLayerTree(node.children)
                        : [];
                    if (!this.isCuuHoLayer(node) && filteredChildren.length === 0) return null;
                    if (!Array.isArray(node.children)) return node;
                    return {
                        ...node,
                        children: filteredChildren
                    };
                })
                .filter(Boolean);
        },
        isFileMapLayer(node) {
            if (node?.dataType === 'raster' || node?.dataType === 'geojson') return true;
            return Array.isArray(node?.children) && node.children.every(child => this.isFileMapLayer(child));
        },
        syncSelectedLayerItems(selectedLayers = []) {
            this.listSelectedId = (selectedLayers ?? []).map(item => item.id);
            this.listLayerPoint = this.listPoint.filter(item => this.listSelectedId.includes(item.layerId));
            this.listLayerPhoto = this.listPhoto.filter(item => this.listSelectedId.includes(item.layerId));
            this.syncCuuHoList();
        },
        syncCuuHoList() {
            this.listCuuHo = this.listPhoto
                .filter(item => String(item.layerId) === String(this.cuuHoId))
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        },
        async updateLayer(newValue, oldValue) {
            this.loading = true;
            const map = this.$refs.myMap.mapObject;
            const listRemoved = (oldValue ?? []).filter(item => !(newValue ?? []).includes(item));

            for (const it of listRemoved) {
                const id = it.id;
                for (const item of this.listLayerActive[id] ?? []) {
                    map.removeLayer(item);
                }
                delete this.listLayerActive[id];
            }

            for (const it of newValue ?? []) {
                if (!this.listLayerActive[it.id]) this.listLayerActive[it.id] = [];
            }

            this.loading = false;
        },
        isImage(url) {
            return url.match(/\.(jpeg|jpg|gif|png|svg|webp|bmp|ico|tiff|tif|raw|heif|heic)$/);
        },
        getMarkerColor1(item) {
            if (!item.data) return '#00800080';
            for (const it of item.legend ?? []) {
                if (item.data.value <= it.value) {
                    return it.color + '80';
                }
            }
            if (item.legend && item.legend.length > 0) {
                const lastColor = item.legend[item.legend.length - 1].color;
                return lastColor + '80';
            }
            return '#00800080';
        },
        getMarkerColor2(item) {
            if (!item.data) return '#008000';
            for (const it of item.legend ?? []) {
                if (item.data.value <= it.value) return it.color;
            }
            if (item.legend && item.legend.length > 0) {
                const lastColor = item.legend[item.legend.length - 1].color;
                return lastColor;
            }
            return '#008000';
        },
        async openCuuHoModal(latitude, longitude) {
            const defaultLayer = this.helpSelectableLayers.find(
                item => String(item.id) === String(this.cuuHoId)
            ) || this.helpSelectableLayers[0];

            this.showCuuHoModal = true;
            this.listFile = [];
            this.form = {
                lat: Number.isFinite(Number(latitude)) ? Number(latitude).toFixed(4) : '',
                long: Number.isFinite(Number(longitude)) ? Number(longitude).toFixed(4) : '',
                layerId: defaultLayer?.id ?? null,
                name: ''
            };

            if (!this.form.lat || !this.form.long) return;
            try {
                const response = await fetch(
                    `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
                );
                const data = await response.json();
                this.form.name = data?.display_name || '';
            } catch (error) { }
        },
        async openUploadImageModal() {
            try {
                const { coords } = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject);
                });
                await this.openCuuHoModal(coords?.latitude, coords?.longitude);
            } catch (error) {
                this.$toaster.error('Lỗi lấy thông tin vị trí');
                await this.openCuuHoModal(null, null);
            }
        },
        async handleMapClickCuuHo(event) {
            if (this.isMapEventOnInteractiveElement(event)) return;
            await this.openCuuHoModal(event.latlng?.lat, event.latlng?.lng);
        },
        handleMapMouseMove(event) {
            if (this.isMapEventOnInteractiveElement(event)) {
                this.showMapTooltip = false;
                return;
            }

            this.showMapTooltip = true;
            this.tooltipPosition = {
                x: event.containerPoint.x + 10,
                y: event.containerPoint.y - 10
            };
        },
        hideMapTooltip() {
            this.showMapTooltip = false;
        },
        isMapEventOnInteractiveElement(event) {
            const target = event?.originalEvent?.target;
            if (!target) return false;
            return Boolean(
                target.closest('.leaflet-control') ||
                target.closest('.leaflet-marker-icon') ||
                target.closest('.leaflet-popup') ||
                target.closest('.leaflet-tooltip') ||
                target.closest('button') ||
                target.closest('a') ||
                target.classList.contains('leaflet-interactive') ||
                target.classList.contains('leaflet-marker-icon')
            );
        },
        async updateLocate(modal) {
            modal.preventDefault();
            const result = await this.$validator.validateAll();
            if (!result) return;
            this.loading = true;
            for (const file of this.listFile) {
                const data = await this.upload({ formData: { file } });
                this.form.images = this.form.images || [];
                this.form.images.push(data.path);
            }
            await this.createPhotoPoint(this.form);
            this.showCuuHoModal = false;
            this.listPhoto = await this.getListPhoto();
            this.syncSelectedLayerItems(this.selectedLayerMap);
            this.$toaster.success('Thành công');
            this.loading = false;
        },
        setCurrentLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.showPosition);
            } else {
                this.$toaster.error('Không thể lấy thông tin vị trí hiện tại');
            }
        },
        async showPosition(position) {
            this.form = {
                lat: position.coords.latitude.toFixed(4),
                long: position.coords.longitude.toFixed(4)
            };
        },
        getPhotoIcon(item) {
            if (!item.layer?.pointIcon) return '/img/image.png';
            return API_CONFIG.BASE_URL + 'download?fileName=' + item.layer.pointIcon;
        },
        formatNumber(value) {
            if (value == null) return '';
            if (value % 1 === 0) return value;
            return value.toFixed(1);
        },
        onClickCuuHoItem(item) {
            const map = this.$refs.myMap?.mapObject;
            const lat = Number(item?.lat);
            const long = Number(item?.long);
            if (!map || !Number.isFinite(lat) || !Number.isFinite(long)) return;

            map.setView([lat, long], 16);
            map.eachLayer(layer => {
                if (!(layer instanceof L.Marker)) return;
                const latlng = layer.getLatLng();
                if (latlng.lat === lat && latlng.lng === long) {
                    layer.openPopup();
                }
            });
        },
        async savePhotoItem(item) {
            await this.updatePhotoPoint(item);
            this.$toaster.success('Lưu thành công');
        },
        makeEmergencyCall() {
            try {
                window.open('tel:0961776683', '_self');
            } catch (error) {
                this.$toaster.info('Vui lòng gọi số khẩn cấp: 0961776683');
            }
        },
        formatRelativeTime(time) {
            if (!time) return '';
            return this.$moment(time).locale('vi').fromNow();
        },
        getDefaultLayer(listLayer) {
            let list = [];
            for (const item of listLayer) {
                if (item.children && item.children.length > 0) {
                    list = list.concat(this.getDefaultLayer(item.children));
                } else {
                    if (item.defaultShow) list.push(item);
                }
            }
            return list;
        },
        handleClickOutside(event) {
            if (!this.showLeftSide) return;
            const leftSidePanel = this.$refs.leftSidePanel;
            if (leftSidePanel && !leftSidePanel.contains(event.target)) {
                this.showLeftSide = false;
            }
        }
    }
};
</script>

<style lang="scss">
.leaflet-popup-content {
    text-align: center !important;
    width: unset !important;
}

.leaflet-marker-photo b {
    height: 16px !important;
    min-width: 16px !important;
}

.station-bg {
    margin-left: -12px !important;
    margin-top: -12px !important;
    width: 32px !important;
    height: 32px !important;
    z-index: 302 !important;
    background-clip: padding-box;
    border-radius: 20px;

    div {
        width: 24px;
        height: 24px;
        margin-left: 4px;
        margin-top: 4px;
        text-align: center;
        border-radius: 15px;
        font-weight: 700;
        color: #fff;
        display: inline-block;
    }

    span {
        line-height: 24px;
    }
}

.leaflet-control-search {
    .search-input {
        min-width: 150px;
    }
}

.station-modal {
    .modal-content {
        border-radius: 10px;

        .modal-body {
            padding: 0.5rem;
        }
    }
}

.photo-img {
    width: 200px;
    height: auto;
}

@media screen and (max-width: 500px) {
    .station-modal {
        .modal-dialog {
            margin: 1.75rem;
        }
    }

    .btn-label {
        display: none;
    }

    .photo-img {
        max-width: 30%;
        height: auto;
    }
}

.detail-card {
    border-radius: 10px;

    .card-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
}

.history-card {
    border-radius: 10px;
    margin-bottom: 0;

    .card-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
}

.region-label {
    font-size: 14px;
    z-index: 400 !important;
    height: auto !important;
    width: 90px !important;
}

.map-tooltip {
    position: absolute;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.emergency-call-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #dc3545;
    color: white;
    border-radius: 50px;
    padding: 15px 20px;
    cursor: pointer;
    z-index: 1001;
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: bold;
    font-size: 14px;
    min-width: 120px;
    justify-content: center;

    &:hover {
        background: #c82333;
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(220, 53, 69, 0.6);
    }

    &:active {
        transform: translateY(0);
    }

    i {
        font-size: 16px;
        animation: ring 2s infinite;
    }
}

@keyframes ring {

    0%,
    20%,
    50%,
    80%,
    100% {
        transform: rotate(0deg);
    }

    10% {
        transform: rotate(-10deg);
    }

    30% {
        transform: rotate(10deg);
    }

    60% {
        transform: rotate(-5deg);
    }

    90% {
        transform: rotate(5deg);
    }
}

.summary-treeselect {

    .vue-treeselect__multi-value-item-container,
    .vue-treeselect__limit-tip {
        display: none;
    }

    &.vue-treeselect--has-value .vue-treeselect__placeholder.vue-treeselect-helper-hide {
        display: block !important;
    }
}
</style>
